import { RoicValues, RoicResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// Simplified ROIC: (Net income after tax - Dividends) / (Long-term debt + Equity)
export function calculateRoic(values: RoicValues, t?: ToolsTranslations['roic']): RoicResult {
  const { netIncomeAfterTax, dividends, longTermDebt, equity } = values;

  if (netIncomeAfterTax < 0) return { roicPercent: null, isValid: false, message: t?.invalid.netIncomeAfterTax };
  if (dividends < 0) return { roicPercent: null, isValid: false, message: t?.invalid.dividends };
  if (longTermDebt < 0) return { roicPercent: null, isValid: false, message: t?.invalid.longTermDebt };
  if (equity <= 0) return { roicPercent: null, isValid: false, message: t?.invalid.equity };

  const investedCapital = longTermDebt + equity;
  if (investedCapital <= 0) return { roicPercent: null, isValid: false, message: t?.invalid.generic };

  const nopatApprox = netIncomeAfterTax - dividends; // per simplified model
  const roic = (nopatApprox / investedCapital) * 100;
  const roicPercent = Math.round(roic); // integer percent for display
  if (!isFinite(roicPercent)) return { roicPercent: null, isValid: false, message: t?.invalid.generic };

  return { roicPercent, isValid: true };
}


